import { useCallback } from 'react';

import { usePintoAnnouncementNotificationDeleteMutation } from '../core/graphql/operation-hooks';

const useMutationPintoAnnouncementNotificationDelete = () => {
  const [mutatePintoAnnouncementNotificationDelete] = usePintoAnnouncementNotificationDeleteMutation();

  const deleteNoti = useCallback(
    async (id: string) => {
      const resp = await mutatePintoAnnouncementNotificationDelete({
        variables: { announcementNotificationId: id },
        refetchQueries: ['PintoAnnouncementNotifications'],
      });

      return resp.data?.deletePintoAnnouncementNotification._id;
    },
    [mutatePintoAnnouncementNotificationDelete],
  );

  return {
    deleteNoti,
  };
};

export default useMutationPintoAnnouncementNotificationDelete;
